import { classNames } from "@/lib/format";
import {
  ONLINE_BOOKING_SECTIONS,
  ONLINE_BOOKING_TAB_GROUPS,
  type OnlineBookingTab,
} from "@/pages/stammdaten/onlineBookingSections";

interface OnlineBookingSectionNavProps {
  tab: OnlineBookingTab;
  onTab: (tab: OnlineBookingTab) => void;
}

export function OnlineBookingSectionNav({ tab, onTab }: OnlineBookingSectionNavProps) {
  const sectionById = Object.fromEntries(
    ONLINE_BOOKING_SECTIONS.map((section) => [section.id, section]),
  ) as Record<OnlineBookingTab, (typeof ONLINE_BOOKING_SECTIONS)[number]>;

  return (
    <nav
      aria-label="Online-Buchung Bereiche"
      className="space-y-2"
    >
      <div
        className="flex gap-1 overflow-x-auto overscroll-x-contain rounded-xl border border-separator bg-grouped p-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        role="tablist"
      >
        {ONLINE_BOOKING_TAB_GROUPS.map((group, groupIndex) => (
          <div key={group.label} className="flex shrink-0 items-center gap-1">
            {groupIndex > 0 ? (
              <span
                className="mx-0.5 hidden h-5 w-px shrink-0 bg-separator sm:block"
                aria-hidden
              />
            ) : null}
            {group.tabs.map((tabId) => {
              const section = sectionById[tabId];
              const isActive = tab === tabId;
              return (
                <button
                  key={tabId}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  title={section.description}
                  className={classNames(
                    "shrink-0 rounded-lg px-3 py-2 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-accent text-label-on-accent shadow-sm"
                      : "text-label-secondary hover:bg-fill hover:text-label",
                  )}
                  onClick={() => onTab(tabId)}
                >
                  <span className="hidden sm:inline">{section.label}</span>
                  <span className="sm:hidden">{section.shortLabel}</span>
                </button>
              );
            })}
          </div>
        ))}
      </div>
      {tab !== "overview" ? (
        <p className="text-sm text-label-secondary">
          {sectionById[tab].description}
        </p>
      ) : null}
    </nav>
  );
}
